const getMapsGoogleLink = (address: string) => {
    return `https://www.google.pl/maps/place/${encodeURI(address)}`;
};

const getMapsAppleLink = (address: string) => {
    return `https://maps.apple.com/?daddr=${encodeURI(address)}`;
};

export function getMapsLink(isIos: boolean, address: string): string {
    if (isIos) {
        return getMapsAppleLink(address);
    }
    return getMapsGoogleLink(address);
};